<template>
    <div class="col-md-6 col-12">
        <h3 class="card-title ml-sm-4 mt-sm-2">Datos del abonado: {{ abonado.name }} {{ abonado.surnames }}</h3><br/><br/>
        <div class="mb-2">
            <b-list-group-item>
                <b>Nª de abonado: </b> {{ abonado.n_abonado }}
            </b-list-group-item>
            <b-list-group-item>
                <b>Nª de abonado(temporada anterior): </b> {{ abonado.n_abonado_antiguo ? abonado.n_abonado_antiguo : 'No' }}  
            </b-list-group-item>
            <b-list-group-item>
                <b>Nombre: </b> <a>{{ abonado.name }}</a>
            </b-list-group-item>
            <b-list-group-item>
                <b>Apellidos: </b> <a>{{ abonado.surnames }}</a>
            </b-list-group-item>
            <b-list-group-item>
                <b>Género: </b> <a>{{ abonado.genero }}</a>
            </b-list-group-item>

            <template v-if="!manager.lfp">
                <b-list-group-item>
                    <b>Fecha de nacimiento: </b> <a>{{ abonado.fecha_nacimiento }}</a>
                </b-list-group-item>
                <b-list-group-item>
                    <b>Teléfono: </b> <a>{{ abonado.telefono }}</a>
                </b-list-group-item>
                <b-list-group-item>
                    <b>Móvil: </b> <a>{{ abonado.movil }}</a>
                </b-list-group-item>
                <b-list-group-item>
                    <b>DNI: </b> <a>{{ abonado.dni }}</a>
                </b-list-group-item>
                <b-list-group-item>
                    <b>País:</b> {{ abonado.pais }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Provincia:</b> {{ abonado.provincia }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Localidad: </b> {{ abonado.localidad }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Domicilio:</b> {{ abonado.domicilio }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>CP/ZIP CODE:</b> {{ abonado.cp }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Email: </b> <a>{{ abonado.email }}</a>
                </b-list-group-item>
                <b-list-group-item>
                    <b>Peña: </b> {{ abonado.penista }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Empresa: </b> {{ abonado.empresa }}
                </b-list-group-item>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['abonado', 'manager']
    }
</script>